import request from '@/utils/request'


// 查询科室认证信息列表
export function listPlatformDepart(query) {
  return request({
    url: '/depart/depart/list',
    method: 'get',
    params: query
  })
}


// 查询科室认证信息分页
export function pageDepart(query) {
  return request({
    url: '/depart/depart/page',
    method: 'get',
    params: query
  })
}

export function treeDepart(query) {
  return request({
    url: '/depart/depart/tree',
    method: 'get',
    params: query
  })
}

// 查询科室认证信息详细
export function getDepart(data) {
  return request({
    url: '/depart/depart/detail',
    method: 'get',
    params: data
  })
}

// 新增科室认证信息
export function addDepart(data) {
  return request({
    url: '/depart/depart/add',
    method: 'post',
    data: data
  })
}

// 修改科室认证信息
export function updateDepart(data) {
  return request({
    url: '/depart/depart/edit',
    method: 'post',
    data: data
  })
}

// 删除科室认证信息
export function delDepart(data) {
  return request({
    url: '/depart/depart/delete',
    method: 'post',
    data: data
  })
}

export function importDepart(data) {
  return request({
    url: '/depart/depart/import',
    method: 'post',
    data: data
  })
}
